import { render, staticRenderFns } from "./account-gender.vue?vue&type=template&id=74c00420&"
import script from "./account-gender.vue?vue&type=script&lang=js&"
export * from "./account-gender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports